import React from "react";
import ProductDetails from "../Components/product/ProductDetails";
import PageHeader from "../Components/common/PageHeader";
import { t } from "i18next";
import SEO from '../Components/common/SEO';

function ProductDetailsPage() {
  // Varsayım: product state/prop ile geliyor
  const product = /* mevcut kodundan ürünü al */ null; // burayı kendi veri akışına göre doldur
  return (
    <>
    <PageHeader title={t("ÇAMAŞIR SUYU")} />
      <ProductDetails />  
    </>
  );
  const siteUrl = 'https://your-domain.com';
  const productUrl = `${siteUrl}/urun/${product?.slug || 'urun'}`;
  const productImage = `${siteUrl}/${product?.image || 'assets/images/og-default.webp'}`;

  const productStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    'name': product?.name,
    'description': product?.description,
    'image': [productImage],
    'brand': { '@type': 'Brand', 'name': 'Seymen Kimya' },
    'sku': product?.sku || product?.id,
    'offers': {
      '@type': 'Offer',
      'priceCurrency': 'TRY',
      'price': product?.price || '0',
      'availability': 'https://schema.org/InStock',
      'url': productUrl
    },
    'aggregateRating': product?.rating ? {
      '@type': 'AggregateRating',
      'ratingValue': product.rating.value,
      'ratingCount': product.rating.count
    } : undefined
  };

  return (
    <>
      <SEO
        title={`${product?.name} | Seymen Kimya`}
        description={product?.description || 'Seymen Kimya ürünleri'}
        canonical={productUrl}
        type="product"
        image={productImage}
        structuredData={productStructuredData}
      />
    </>
  );
}

export default ProductDetailsPage;
